<template>
    <div id="optimizedpaintlistviewpage">
        <actions-menu>
            <actions-menu-item
                :v4="true"
                :action="() => $router.push('/paintlistform')"
                icon="arrow-left"
                :label="trans('pages.optimized_productlistview.to_overview')"
            />
            <actions-menu-item
                :v4="true"
                :action="updateOptimizedPaintlistSawnStatus"
                icon="check"
                :label="trans('pages.optimized_productlistview.sawed')"
            />
            <actions-menu-item
                :v4="true"
                v-if="hasRight('productionmanagement')"
                :action="() => $router.push('/paintlistcreate/-1/' + idParam)"
                icon="pencil"
                :label="trans('pages.optimized_productlistview.modify')"
            />
            <actions-menu-item
                :v4="true"
                v-if="hasRight('productionmanagement')"
                :action="removePaintlist"
                icon="exclamation-circle"
                class="alert"
                :label="trans('pages.optimized_productlistview.delete')"
            />
            <actions-menu-item
                :v4="true"
                :action="exportInternal"
                icon="floppy-o"
                :label="
                    trans('pages.optimized_productlistview.export_paintlist')
                "
            />
            <actions-menu-item
                :v4="true"
                :action="printProducts"
                icon="tag"
                :label="
                    trans(
                        'pages.optimized_productlistview.print_product_labels'
                    )
                "
            />
            <actions-menu-item
                :v4="true"
                :action="printWindowLabelsForPaintlistAction"
                icon="tag"
                :label="
                    trans('pages.optimized_productlistview.print_window_labels')
                "
            />
            <actions-menu-item
                :v4="true"
                :action="() => $router.push('/work-post-paint-screen')"
                icon="arrow-right"
                :label="trans('pages.optimized_productlistview.to_paint_shop')"
            />
        </actions-menu>

        <loader v-if="loading" />
        <template v-else>
            <div class="next-previous-buttons">
                <ui5-button
                    @click="
                        previous
                            ? $router.push(
                                  '/optimizedpaintlistview/' + previous
                              )
                            : () => {}
                    "
                    :disabled="!previous"
                >
                    {{ trans('pages.optimized_productlistview.previous') }}
                    <template v-if="previous">
                        {{ optimizedPaintList.paintworkform }}
                    </template>
                </ui5-button>
                <ui5-button
                    @click="
                        next
                            ? $router.push('/optimizedpaintlistview/' + next)
                            : () => {}
                    "
                    :disabled="!next"
                >
                    {{ trans('pages.optimized_productlistview.next') }}
                    <template v-if="next">
                        {{ optimizedPaintList.paintworkform }}
                    </template>
                </ui5-button>
            </div>
            <div class="container row">
                <div class="barcode-container">
                    <barcode
                        v-if="idParam"
                        :value="idParam"
                        format="CODE128"
                        font-size="18"
                        text-margin="0"
                    >
                        Barcode {{ idParam }}
                    </barcode>
                    <br />
                </div>
                <div class="col-100">
                    <div class="paintlist-title">
                        <h1>
                            {{
                                trans(
                                    'pages.optimized_productlistview.production_order_paint_work'
                                )
                            }}
                        </h1>
                        <div
                            id="lakbon-finished"
                            v-if="isPaintListCompleted"
                        >
                            <h2>
                                {{
                                    trans(
                                        'pages.optimized_productlistview.paint_order_finished'
                                    )
                                }}
                            </h2>
                        </div>
                    </div>

                    <div class="top-row">
                        <div class="col1">
                            <div class="urgent-container">
                                <ui5-checkbox
                                    :checked="
                                        optimizedPaintList
                                            ? optimizedPaintList.urgent
                                            : false
                                    "
                                    @change="
                                        optimizedPaintList.urgent =
                                            $event.target.checked;
                                        updateUrgent();
                                    "
                                    :disabled="
                                        !optimizedPaintList ||
                                        optimizedPaintList.paintworkform
                                    "
                                    :text="
                                        trans(
                                            'pages.optimized_productlistview.closed'
                                        )
                                    "
                                />
                                <i
                                    class="fa fa-question-circle"
                                    @mouseover="
                                        $refs.tooltipUrgent.showAt(
                                            $event.target
                                        )
                                    "
                                    @mouseout="$refs.tooltipUrgent.close()"
                                />
                                <ui5-popover
                                    ref="tooltipUrgent"
                                    :allow-target-overlap="false"
                                    placement-type="Bottom"
                                >
                                    <div>
                                        {{
                                            trans(
                                                'pages.optimized_productlistview.closed_tooltip'
                                            )
                                        }}
                                    </div>
                                </ui5-popover>
                            </div>
                            <div>
                                <ui5-label for="paintlisttype">
                                    {{
                                        trans(
                                            'pages.optimized_productlistview.type'
                                        )
                                    }}
                                </ui5-label>
                                <ui5-select
                                    :disabled="
                                        !optimizedPaintList ||
                                        optimizedPaintList.paintworkform
                                    "
                                    @change="
                                        optimizedPaintList.type =
                                            $event.detail.selectedOption.value;
                                        updateType();
                                    "
                                    id="paintlisttype"
                                >
                                    <ui5-option
                                        v-for="option in paintListTypeOptions()"
                                        :key="option.id"
                                        :value="option.id"
                                        :selected="
                                            optimizedPaintList &&
                                            optimizedPaintList.type == option.id
                                        "
                                    >
                                        {{
                                            trans(
                                                'paint_lists.types.' +
                                                    option.key
                                            )
                                        }}
                                    </ui5-option>
                                </ui5-select>
                            </div>
                        </div>

                        <div class="col2">
                            <div class="basket-container">
                                <ui5-label for="korf">
                                    <span>
                                        {{
                                            trans(
                                                'pages.optimized_productlistview.baskets'
                                            )
                                        }}
                                    </span>
                                    <i
                                        class="fa fa-question-circle"
                                        @mouseover="
                                            $refs.tooltipBasket.showAt(
                                                $event.target
                                            )
                                        "
                                        @mouseout="$refs.tooltipBasket.close()"
                                    />
                                </ui5-label>
                                <ui5-popover
                                    ref="tooltipBasket"
                                    :allow-target-overlap="false"
                                    placement-type="Bottom"
                                >
                                    <div>
                                        {{
                                            trans(
                                                'pages.optimized_productlistview.baskets_tooltip'
                                            )
                                        }}
                                    </div>
                                </ui5-popover>
                                <div
                                    id="korven"
                                    v-if="optimizedPaintList"
                                >
                                    <span
                                        v-for="(
                                            basket, basketIndex
                                        ) in optimizedPaintList.korven"
                                        :key="'basket.' + basketIndex"
                                    >
                                        <span class="basketName">
                                            {{ basket }}
                                        </span>
                                        <i
                                            class="fa fa-times"
                                            @click="
                                                removeBasketClick(
                                                    basket,
                                                    basketIndex
                                                )
                                            "
                                        />
                                        &nbsp;
                                    </span>
                                </div>
                            </div>
                            <div class="new-basket-container">
                                <ui5-input
                                    @input="newBasket = $event.target.value"
                                    @change="newBasket = $event.target.value"
                                    :value="newBasket"
                                    @suggestion-item-select="
                                        newBasket = $event.detail.item.text
                                    "
                                    @keypress.enter="addSelectedBasket"
                                    :show-suggestions="true"
                                >
                                    <ui5-suggestion-item
                                        v-for="(
                                            basket, basketIndex
                                        ) in remainingBaskets"
                                        v-if="showSuggestion(basket)"
                                        :key="'basketSuggestion.' + basketIndex"
                                        :text="basket"
                                    />
                                </ui5-input>
                                <ui5-button @click="addSelectedBasket">
                                    {{
                                        trans(
                                            'pages.optimized_productlistview.add'
                                        )
                                    }}
                                </ui5-button>
                            </div>

                            <div>
                                <ui5-label for="volgnummer">
                                    {{
                                        trans(
                                            'pages.optimized_productlistview.sequence_number'
                                        )
                                    }}
                                </ui5-label>
                                <br />
                                <text-input
                                    type="number"
                                    name="volgnummer"
                                    id="volgnummer"
                                    :disabled="!optimizedPaintList"
                                    :value="
                                        optimizedPaintList
                                            ? optimizedPaintList.trackNr
                                            : ''
                                    "
                                    @input="
                                        optimizedPaintList.trackNr =
                                            $event || '0'
                                    "
                                    @blur="updateTrackNrForPaintlist"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container row">
                <div class="col-90">
                    <div class="paintlist-field">
                        <ui5-label>
                            {{
                                trans(
                                    'pages.optimized_productlistview.description'
                                )
                            }}
                        </ui5-label>
                        <ui5-textarea
                            name="paintlistdescription"
                            id="paintlistdescription"
                            @focusout="updateDescription"
                            :disabled="!optimizedPaintList"
                            :value="
                                optimizedPaintList
                                    ? optimizedPaintList.description
                                    : ''
                            "
                            @input="
                                optimizedPaintList.description =
                                    $event.target.value
                            "
                        />
                    </div>
                </div>
            </div>
            <div class="box">
                <div class="box-title">
                    {{ trans('pages.optimized_productlistview.info') }}
                </div>

                <div class="box-row">
                    <div class="box-25">
                        {{
                            trans(
                                'pages.optimized_productlistview.production_order_number'
                            )
                        }}
                    </div>
                    <div class="box-25">
                        <span
                            id="paintlistviewid"
                            v-if="optimizedPaintList"
                        >
                            {{ optimizedPaintList.ID }}
                        </span>
                    </div>

                    <div class="box-25">
                        {{
                            trans('pages.optimized_productlistview.paint_shop')
                        }}
                    </div>
                    <div class="box-25">
                        <span
                            id="paintlistviewpaintshop"
                            v-if="
                                optimizedPaintList &&
                                optimizedPaintList.paintshop
                            "
                        >
                            {{ optimizedPaintList.paintshop.name }}
                        </span>
                    </div>
                </div>

                <div class="box-row">
                    <div class="box-25">
                        {{
                            trans(
                                'pages.optimized_productlistview.paint_work_order'
                            )
                        }}
                    </div>
                    <div class="box-25">
                        <span
                            id="paintlistviewworkform"
                            v-if="optimizedPaintList"
                        >
                            {{ optimizedPaintList.paintworkform }}
                        </span>
                    </div>

                    <div class="box-25">
                        {{
                            trans(
                                'pages.optimized_productlistview.our_reference'
                            )
                        }}
                    </div>
                    <div class="box-25">
                        <span
                            id="paintlistviewref"
                            v-if="optimizedPaintList"
                        >
                            {{ optimizedPaintList.reference }}
                        </span>
                    </div>
                </div>

                <div class="box-row">
                    <div class="box-25">
                        {{ trans('pages.optimized_productlistview.deadline') }}
                    </div>
                    <div class="box-25">
                        <span
                            id="paintlistdeadline"
                            v-if="optimizedPaintList"
                        >
                            {{ optimizedPaintList.deadline }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-50">
                    <div
                        id="box-color"
                        class="box"
                    >
                        <div class="box-title">
                            {{ trans('pages.optimized_productlistview.color') }}
                        </div>

                        <div class="box-row">
                            <div class="box-50">
                                {{
                                    trans(
                                        'pages.optimized_productlistview.ral_color'
                                    )
                                }}
                            </div>
                            <div class="box-50">
                                <div
                                    class="paintlistelementvalue"
                                    v-if="optimizedPaintList"
                                >
                                    {{ optimizedPaintList.ral }}
                                </div>
                            </div>
                        </div>

                        <div class="box-row">
                            <div class="box-50">
                                {{
                                    trans(
                                        'pages.optimized_productlistview.powder_number'
                                    )
                                }}
                            </div>
                            <div class="box-50">
                                <div
                                    class="paintlistelementvalue"
                                    v-if="optimizedPaintList"
                                >
                                    {{ optimizedPaintList.poeder }}
                                </div>
                            </div>
                        </div>

                        <div class="box-row">
                            <div class="box-50">
                                {{
                                    trans(
                                        'pages.optimized_productlistview.brand'
                                    )
                                }}
                            </div>
                            <div class="box-50">
                                <div
                                    class="paintlistelementvalue"
                                    v-if="optimizedPaintList"
                                >
                                    {{ optimizedPaintList.producent }}
                                </div>
                            </div>
                        </div>

                        <div class="box-row">
                            <div class="box-50">
                                {{
                                    trans(
                                        'pages.optimized_productlistview.info'
                                    )
                                }}
                            </div>
                            <div class="box-50">
                                <div
                                    class="paintlistelementvalue"
                                    v-if="optimizedPaintList"
                                >
                                    {{ optimizedPaintList.colornotes }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-50">
                    <div
                        id="box-contents"
                        class="box"
                    >
                        <div class="box-title">
                            {{
                                trans(
                                    'pages.optimized_productlistview.package_contents'
                                )
                            }}
                        </div>

                        <div class="box-row">
                            <div class="box-50">
                                {{
                                    trans(
                                        'pages.optimized_productlistview.total_count'
                                    )
                                }}
                            </div>
                            <div class="box-50">
                                <div
                                    class="paintlistelementvalue paintlistbold"
                                    v-if="optimizedPaintList"
                                >
                                    {{ optimizedPaintList.count }}
                                </div>
                            </div>
                        </div>

                        <div class="box-row">
                            <div class="box-50">
                                {{
                                    trans(
                                        'pages.optimized_productlistview.total_area'
                                    )
                                }}
                            </div>
                            <div class="box-50">
                                <div
                                    class="paintlistelementvalue paintlistbold"
                                    v-if="optimizedPaintList"
                                >
                                    {{ (optimizedPaintList.area ? optimizedPaintList.area : 0).toFixed(2) }} m&#178;
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <h4>
                {{
                    trans('pages.optimized_productlistview.products_in_package')
                }}
            </h4>
            <div
                id="paintlistproductview"
                v-if="optimizedPaintList"
            >
                <div
                    v-for="product in optimizedPaintList.products || []"
                    class="productiditem link"
                    @click="goToProductPage(product.ID)"
                >
                    {{ product.productNr }}
                </div>
            </div>

            <h4>
                {{
                    trans('pages.optimized_productlistview.profiles_in_package')
                }}
            </h4>
            <div
                class="paintlist-actions-container"
                v-if="optimizedPaintList"
            >
                <ui5-button
                    @click="splitPaintlistRecord"
                    :disabled="showActionOverlay"
                >
                    {{ trans('pages.optimized_productlistview.split_line') }}
                </ui5-button>
                <ui5-button
                    @click="combinePaintlistRecords"
                    :disabled="showActionOverlay"
                >
                    {{ trans('pages.optimized_productlistview.merge_lines') }}
                </ui5-button>
                <ui5-button
                    @click="combinePaintlistAmounts"
                    :disabled="showActionOverlay"
                >
                    {{ trans('pages.optimized_productlistview.merge_amounts') }}
                </ui5-button>
                <ui5-button
                    @click="equalizeLengths"
                    :disabled="showActionOverlay"
                >
                    {{
                        trans(
                            'pages.optimized_productlistview.equalize_lengths'
                        )
                    }}
                </ui5-button>
                <ui5-button
                    @click="useProfileLengthForPaintlistRecord"
                    :disabled="showActionOverlay"
                >
                    {{
                        trans(
                            'pages.optimized_productlistview.use_profile_length'
                        )
                    }}
                </ui5-button>
            </div>

            <table
                cellspacing="0"
                cellpadding="0"
                id="profile-overview"
                class="product-table"
            >
                <thead>
                    <tr class="product-table-header-tr">
                        <th class="product-table-header-td"></th>
                        <th class="product-table-header-td"></th>
                        <th class="product-table-header-td">
                            {{
                                trans('pages.optimized_productlistview.select')
                            }}
                        </th>
                        <th class="product-table-header-td">
                            {{ trans('pages.optimized_productlistview.rack') }}
                        </th>
                        <th class="product-table-header-td">
                            {{ trans('pages.optimized_productlistview.image') }}
                        </th>
                        <th
                            class="product-table-header-td"
                            align="left"
                        >
                            {{
                                trans(
                                    'pages.optimized_productlistview.description'
                                )
                            }}
                        </th>
                        <th
                            class="product-table-header-td"
                            align="center"
                        >
                            {{
                                trans(
                                    'pages.optimized_productlistview.products'
                                )
                            }}
                        </th>
                        <th
                            class="product-table-header-td"
                            align="center"
                        >
                            {{
                                trans('pages.optimized_productlistview.length')
                            }}
                        </th>
                        <th
                            class="product-table-header-td"
                            align="center"
                        >
                            {{
                                trans('pages.optimized_productlistview.amount')
                            }}
                        </th>
                        <th
                            class="product-table-header-td"
                            align="center"
                        >
                            {{
                                trans(
                                    'pages.optimized_productlistview.finished'
                                )
                            }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <li v-if="profiles.length == 0">
                        {{
                            trans('pages.optimized_productlistview.no_profiles')
                        }}
                    </li>
                    <template v-else></template>
                    <tr
                        v-for="record in profiles"
                        :key="'record.' + record.ID"
                        :id="'profile-row-' + record.ID"
                        class="product-table-item-tr"
                    >
                        <td class="bol-cell">
                            <div
                                :id="'left-checkbox-' + record.ID"
                                :style="{
                                    'background-color':
                                        record.sawn == 1 ? 'green' : 'red',
                                }"
                                class="bol"
                            />
                        </td>
                        <td
                            @click="
                                $router.push(
                                    '/paintlistline/' +
                                        idParam +
                                        '/' +
                                        record.ID
                                )
                            "
                            align="center"
                        >
                            <i class="material-icons">search</i>
                        </td>
                        <td align="center">
                            <ui5-checkbox
                                class="paintlistrecord-select"
                                :id="'select-' + record.ID"
                                :checked="record.selected"
                                @change="
                                    record.selected = $event.target.checked
                                "
                            />
                        </td>
                        <td align="center">{{ record.location }}</td>
                        <td align="center">
                            <img
                                :src="getImgSrc(record)"
                                :alt="record.code"
                            />
                        </td>
                        <td align="left">
                            <div>
                                <div class="paintlistbold">
                                    {{ record.description }}
                                </div>
                                <div class="paintlistdefault">
                                    {{ record.code }}
                                </div>
                                <div class="paintlistitalic">
                                    {{
                                        trans(
                                            'pages.optimized_productlistview.profile_circumference'
                                        )
                                    }}
                                    {{ record.contour }}
                                </div>
                                <div
                                    class="paintlistred"
                                    v-if="record.showPaintlist == 0"
                                >
                                    {{
                                        trans(
                                            'pages.optimized_productlistview.do_not_paint'
                                        )
                                    }}
                                </div>
                            </div>
                        </td>
                        <td align="center">
                            <template
                                v-if="
                                    getChildSawLines(record.sawlineId).length >
                                    0
                                "
                            >
                                <span
                                    @click="
                                        showChildSawlines(
                                            getChildSawLines(record.sawlineId)
                                        )
                                    "
                                    class="show-child-sawlines"
                                >
                                    ?
                                </span>
                            </template>
                            <i
                                v-if="record.productsArray.length > 1"
                                class="material-icons"
                                @click="
                                    showProductsforProfileDialog(
                                        record.products,
                                        $event.target
                                    )
                                "
                            >
                                list
                            </i>
                            <p v-if="record.productsArray.length === 1">
                                {{ record.productsArray[0].productNr }}
                            </p>
                        </td>
                        <td align="center">
                            <template v-if="record.isPart == 1">
                                {{ trans('pages.optimized_productlistview.piece') }} ({{ record.area }} m&sup2;)
                            </template>
                            <template v-else>
                                {{ record.length }}
                                {{ trans('pages.optimized_productlistview.mm') }}
                            </template>
                        </td>
                        <td align="center">{{ record.count }}</td>
                        <td
                            :id="'optimizedpaintlistrecord-' + record.ID"
                            align="center"
                        >
                            <ui5-checkbox
                                :checked="record.sawn == 1"
                                class="finished-checkbox"
                                :id="'checkbox-' + record.ID"
                                @change="
                                    optimizedPaintList.records.find(
                                        (x) => x.ID == record.ID
                                    ).sawn = $event.target.checked ? 1 : 0;
                                    updatePaintlistRecordSawn(
                                        record,
                                        $event.target
                                    );
                                "
                            />
                        </td>
                    </tr>
                </tbody>
            </table>

            <div
                class="paintlist-actions-container"
                v-if="optimizedPaintList"
            >
                <ui5-button
                    @click="splitPaintlistRecord"
                    :disabled="showActionOverlay"
                >
                    {{ trans('pages.optimized_productlistview.split_line') }}
                </ui5-button>
                <ui5-button
                    @click="combinePaintlistRecords"
                    :disabled="showActionOverlay"
                >
                    {{ trans('pages.optimized_productlistview.merge_lines') }}
                </ui5-button>
                <ui5-button
                    @click="combinePaintlistAmounts"
                    :disabled="showActionOverlay"
                >
                    {{ trans('pages.optimized_productlistview.merge_amounts') }}
                </ui5-button>
                <ui5-button
                    @click="equalizeLengths"
                    :disabled="showActionOverlay"
                >
                    {{
                        trans(
                            'pages.optimized_productlistview.equalize_lengths'
                        )
                    }}
                </ui5-button>
                <ui5-button
                    @click="useProfileLengthForPaintlistRecord"
                    :disabled="showActionOverlay"
                >
                    {{
                        trans(
                            'pages.optimized_productlistview.use_profile_length'
                        )
                    }}
                </ui5-button>
            </div>

            <div class="next-previous-buttons">
                <ui5-button
                    @click="
                        previous
                            ? $router.push(
                                  '/optimizedpaintlistview/' + previous
                              )
                            : () => {}
                    "
                    :disabled="!previous"
                >
                    {{ trans('pages.optimized_productlistview.previous') }}
                    <template v-if="previous">
                        {{ optimizedPaintList.paintworkform }}
                    </template>
                </ui5-button>
                <ui5-button
                    @click="
                        next
                            ? $router.push('/optimizedpaintlistview/' + next)
                            : () => {}
                    "
                    :disabled="!next"
                >
                    {{ trans('pages.optimized_productlistview.next') }}
                    <template v-if="next">
                        {{ optimizedPaintList.paintworkform }}
                    </template>
                </ui5-button>
            </div>

            <div id="paintlistview" />

            <div
                id="list-child-sawlines-container"
                v-if="showChildsawlinesPopup"
                @click="showChildsawlinesPopup = false"
            >
                <div
                    id="list-child-sawlines"
                    @click.stop="() => {}"
                >
                    <div id="child-sawlines-list">
                        <table class="product-table">
                            <thead>
                                <tr class="product-table-header-tr">
                                    <th
                                        class="product-table-header-td"
                                        colspan="3"
                                    >
                                        {{
                                            trans(
                                                'pages.optimized_productlistview.description'
                                            )
                                        }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody v-if="childSawlines">
                                <template v-for="sawline in childSawlines">
                                    <tr
                                        v-if="sawline.productValues.length == 0"
                                        class="product-table-item-tr"
                                    >
                                        <td colspan="3">
                                            <div class="paintlistbold">
                                                {{ sawline.externalName }}
                                            </div>
                                            <div class="paintlistdefault">
                                                {{ sawline.code }}
                                            </div>
                                            <div
                                                v-if="
                                                    sawline.showPaintlist == 0
                                                "
                                                class="paintlistred"
                                            >
                                                {{
                                                    trans(
                                                        'pages.optimized_productlistview.do_not_paint'
                                                    )
                                                }}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr
                                        v-else
                                        v-for="(
                                            value, productId
                                        ) in sawline.productValues"
                                        class="product-table-item-tr"
                                    >
                                        <td>{{ productId }}</td>
                                        <td>
                                            <div class="paintlistbold">
                                                {{ sawline.externalName }}
                                            </div>
                                            <div class="paintlistdefault">
                                                {{ sawline.code }}
                                            </div>
                                            <div
                                                v-if="
                                                    sawline.showPaintlist == 0
                                                "
                                                class="paintlistred"
                                            >
                                                {{
                                                    trans(
                                                        'pages.optimized_productlistview.do_not_paint'
                                                    )
                                                }}
                                            </div>
                                        </td>
                                        <td>
                                            {{ value }}
                                            {{
                                                trans(
                                                    'pages.optimized_productlistview.mm'
                                                )
                                            }}
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div
                v-show="showActionOverlay"
                id="optimizedpaintlistviewactionoverlay"
            >
                <spinner-text>
                    {{
                        trans(
                            'pages.optimized_productlistview.processing_lines'
                        )
                    }}
                </spinner-text>
            </div>

            <ui5-popover
                ref="productList"
                :header-text="trans('pages.optimized_productlistview.products')"
            >
                <div id="product-list">
                    <template
                        v-if="!popoverProducts || popoverProducts.length == 0"
                    >
                        {{
                            trans(
                                'pages.optimized_productlistview.no_products_for_profile'
                            )
                        }}
                    </template>
                    <div
                        v-for="product in popoverProducts"
                        :key="'popoverProduct.' + product.ID"
                    >
                        {{ product.productNr }}
                    </div>
                </div>
            </ui5-popover>
        </template>
    </div>
</template>
<script>
import ActionsMenu from '../components/ActionsMenu';
import ActionsMenuItem from '../components/ActionsMenuItem';
import optimizedPaintListApi from '../api/optimizedPaintList';
import exportApi from '../api/export';
import ErrorHelper from '../helpers/ErrorHelper';
import IdParamMixin from '../mixins/id-param';
import IsDebugMixin from '../mixins/is-debug';
import NavigationFunctionsMixin from '../mixins/navigation-functions.js';
import VueBarcode from 'vue-barcode';
import SpinnerText from '../components/loader/SpinnerText';
import Loader from '../components/loader/Loader';
import { mapGetters } from 'vuex';
import { precisionRound } from '../helpers/MathHelper';
import { paintListTypeOptions } from '../helpers/PaintListTypeHelper.js';
import {
    showInfoMessage,
    showErrorMessage,
    showConfirmDialog,
} from '../dialogs';
import _ from 'lodash';
import localization from '../mixins/localization';
import TextInput from '../components/TextInput.vue';

export default {
    mixins: [
        IdParamMixin(),
        IsDebugMixin,
        NavigationFunctionsMixin,
        localization,
    ],
    components: {
        Loader,
        SpinnerText,
        ActionsMenu,
        ActionsMenuItem,
        barcode: VueBarcode,
        TextInput,
    },
    data() {
        return {
            oldpaintlistdescriptionValue: '',
            allBaskets: [],
            optimizedPaintList: null,
            newBasket: '',
            popoverProducts: [],
            childSawlines: null,
            showChildsawlinesPopup: false,
            previous: null,
            next: null,
            showActionOverlay: false,
            loading: false,
        };
    },
    computed: {
        ...mapGetters({
            hasRight: 'currentUser/hasRight',
        }),
        selectedPrinterPostParameter() {
            return this.$store.getters[
                'printers/getSelectedPrinterPostParameter'
            ]();
        },
        isPaintListCompleted() {
            if (!this.optimizedPaintList) {
                return false;
            }
            const completed = this.profiles.every((x) => x.sawn == 1);
            if (completed) {
                window.scrollTo(0, 0);
            }
            return completed;
        },
        remainingBaskets() {
            const selectedBaskets = this.optimizedPaintList
                ? [...this.optimizedPaintList.korven]
                : [];
            return this.allBaskets
                .map((x) => x)
                .filter((x) => !selectedBaskets.includes(x));
        },
        profiles() {
            if (!this.optimizedPaintList || !this.optimizedPaintList.records) {
                return [];
            }
            const profiles = this.optimizedPaintList.records.map((record) => {
                const productsArray = this.productsStringToUniqueArray(
                    record.products
                );

                return {
                    ...record,
                    productsArray: productsArray,
                };
            });
            return _.sortBy(profiles, [(p) => p.sawn == 1]);
        },
    },
    methods: {
        paintListTypeOptions,
        precisionRound,
        getChildSawLines(parentId) {
            if (
                !this.optimizedPaintList ||
                !this.optimizedPaintList.childSawlines
            ) {
                return [];
            }
            return this.optimizedPaintList.childSawlines[parentId] || [];
        },
        combinePaintlistAmounts() {
            this.showActionOverlay = true;
            return optimizedPaintListApi
                .combineAllAmounts(this.idParam)
                .then(() => {
                    showInfoMessage(
                        this.trans(
                            'pages.optimized_productlistview.changes_saved'
                        )
                    );
                    this.load();
                })
                .catch((error) => {
                    const translations = {
                        'paintlist.combine.profile': this.trans(
                            'pages.optimized_productlistview.profiles_mismatch'
                        ),
                        'paintlist.combine.length': this.trans(
                            'pages.optimized_productlistview.lengths_mismatch'
                        ),
                    };
                    ErrorHelper.displayError(error, translations);
                })
                .finally(() => {
                    this.showActionOverlay = false;
                });
        },
        combinePaintlistRecords() {
            const selectedRecords = this.getSelectedRecords();
            if (selectedRecords.length < 2) {
                return showErrorMessage(
                    this.trans(
                        'pages.optimized_productlistview.select_min_two_lines'
                    )
                );
            }

            this.showActionOverlay = true;
            return optimizedPaintListApi
                .combineRecords(selectedRecords)
                .then(() => {
                    showInfoMessage(
                        this.trans(
                            'pages.optimized_productlistview.changes_saved'
                        )
                    );
                    this.load();
                })
                .catch((error) => {
                    const translations = {
                        'paintlist.combine.profile': this.trans(
                            'pages.optimized_productlistview.profiles_mismatch'
                        ),
                        'paintlist.combine.count': this.trans(
                            'pages.optimized_productlistview.amounts_mismatch'
                        ),
                        'paintlist.combine.maxlength': this.trans(
                            'pages.optimized_productlistview.max_length_exceeded'
                        ),
                    };
                    ErrorHelper.displayError(error, translations);
                })
                .finally(() => {
                    this.showActionOverlay = false;
                });
        },
        equalizeLengths() {
            this.showActionOverlay = true;
            return optimizedPaintListApi
                .equalizeLengths(this.idParam, this.getSelectedRecords())
                .then(() => {
                    showInfoMessage(
                        this.trans(
                            'pages.optimized_productlistview.changes_saved'
                        )
                    );
                    this.load();
                })
                .catch((error) => {
                    const translations = {
                        'paintlist.equalizelengths.empty': this.trans(
                            'pages.optimized_productlistview.no_profiles_selected'
                        ),
                        'paintlist.equalizelengths.wrongpaintlist': this.trans(
                            'pages.optimized_productlistview.wrong_paint_list'
                        ),
                        'paintlist.equalizelengths.differentprofiles':
                            this.trans(
                                'pages.optimized_productlistview.different_profiles'
                            ),
                    };
                    ErrorHelper.displayError(error, translations);
                })
                .finally(() => {
                    this.showActionOverlay = false;
                });
        },
        splitPaintlistRecord() {
            const selectedRecords = this.getSelectedRecords();
            if (selectedRecords.length !== 1) {
                return showErrorMessage(
                    this.trans(
                        'pages.optimized_productlistview.select_only_one_line'
                    )
                );
            }

            this.showActionOverlay = true;
            return optimizedPaintListApi
                .splitRecord(selectedRecords[0])
                .then(() => {
                    showInfoMessage(
                        this.trans(
                            'pages.optimized_productlistview.changes_saved'
                        )
                    );
                    this.load();
                })
                .catch((error) => {
                    const translations = {
                        'paintlist.split.oldpaintlist': this.trans(
                            'pages.optimized_productlistview.only_new_sawlists'
                        ),
                    };
                    ErrorHelper.displayError(error, translations);
                })
                .finally(() => {
                    this.showActionOverlay = false;
                });
        },
        useProfileLengthForPaintlistRecord() {
            this.showActionOverlay = true;

            const promises = this.getSelectedRecords().map((recordId) =>
                optimizedPaintListApi.useProfileLengthForRecord(recordId)
            );

            return Promise.all(promises)
                .then(() => {
                    showInfoMessage(
                        this.trans(
                            'pages.optimized_productlistview.changes_saved'
                        )
                    );
                    this.load();
                })
                .catch((error) => {
                    const translations = {
                        'paintlist.useprofilelength.error': this.trans(
                            'pages.optimized_productlistview.use_profile_length_error'
                        ),
                    };
                    ErrorHelper.displayError(error, translations);
                })
                .finally(() => {
                    this.showActionOverlay = false;
                });
        },
        getImgSrc(record) {
            return (
                Config.url +
                '/optimizedpaintlist/fetchImageForRecord/?recordId=' +
                record.ID
            );
        },
        showSuggestion(basket) {
            const input = this.newBasket.toUpperCase();
            return basket.toUpperCase().includes(input);
        },
        removeBasketClick(basketName, basketIndex) {
            optimizedPaintListApi
                .removeBasket(basketName, this.idParam)
                .then(() => {
                    showInfoMessage(
                        this.trans(
                            'pages.optimized_productlistview.basket_removed'
                        )
                    );
                    this.$delete(this.optimizedPaintList.korven, basketIndex);
                })
                .catch((error) => {
                    showErrorMessage(
                        this.trans('pages.optimized_productlistview.error') +
                            ErrorHelper.parseError(error.response.data)
                    );
                });
        },
        removePaintlist() {
            showConfirmDialog({
                title: this.trans(
                    'pages.optimized_productlistview.remove_paint_list_title'
                ),
                content: this.trans(
                    'pages.optimized_productlistview.remove_paint_list_confirm'
                ),
                confirm: () => {
                    optimizedPaintListApi
                        .remove(this.idParam)
                        .then(() => {
                            this.$router.push('/paintlistform');
                        })
                        .catch(() => {
                            showErrorMessage(
                                this.trans(
                                    'pages.optimized_productlistview.remove_failed'
                                )
                            );
                        });
                },
                closeOnCancel: true,
                closeOnOk: true,
                confirmButton: this.trans(
                    'pages.optimized_productlistview.yes'
                ),
                cancelButton: this.trans('pages.optimized_productlistview.no'),
            });
        },
        exportInternal() {
            window.open(
                Config.url +
                    '/export/exportPaintlist/?paintlistId=' +
                    this.idParam,
                '_blank'
            );
        },
        addSelectedBasket() {
            if (!this.optimizedPaintList.korven.includes(this.newBasket)) {
                optimizedPaintListApi
                    .addBasket(this.newBasket, this.idParam)
                    .then(() => {
                        showInfoMessage(
                            this.trans(
                                'pages.optimized_productlistview.basket_added'
                            )
                        );
                        this.optimizedPaintList.korven.push(this.newBasket);
                        this.newBasket = '';
                    })
                    .catch((error) => {
                        showErrorMessage(
                            this.trans(
                                'pages.optimized_productlistview.error'
                            ) + ErrorHelper.parseError(error.response.data)
                        );
                    });
            }
        },
        getSelectedRecords() {
            return this.profiles.filter((x) => x.selected).map((x) => x.ID);
        },
        printWindowLabelsForPaintlistAction() {
            KeyHelper.handlePrintOrExport(
                () => exportApi.printWindowLabelsForOptimizedPaintlist(
                    this.idParam,
                    this.selectedPrinterPostParameter,
                    false
                ),
                Config.url +
                    '/export/exportWindowLabelsForOptimizedPaintlist/' +
                    '?optimizedPaintlistId=' +
                    this.idParam
            );
        },
        updateDescription() {
            const description = this.optimizedPaintList.description;

            if (this.oldpaintlistdescriptionValue != description) {
                optimizedPaintListApi
                    .updateDescription(description, this.idParam)
                    .then(() => {
                        showInfoMessage(
                            this.trans(
                                'pages.optimized_productlistview.description_updated'
                            )
                        );
                    })
                    .catch((error) => {
                        showErrorMessage(
                            this.trans(
                                'pages.optimized_productlistview.error'
                            ) + ErrorHelper.parseError(error.response.data)
                        );
                    });
            }

            this.oldpaintlistdescriptionValue = description;
        },
        updateOptimizedPaintlistSawnStatus() {
            showInfoMessage(
                this.trans('pages.optimized_productlistview.status_updating')
            );
            optimizedPaintListApi.updateSawn(this.idParam).then(() => {
                // Set all profiles as sawn
                for (const profile of this.profiles) {
                    profile.sawn = 1;
                }
            });
        },
        productsStringToUniqueArray(products) {
            const listProducts = this.optimizedPaintList.products || [];
            return [
                ...new Set(
                    (products || '')
                        .split(',')
                        .map((x) => listProducts.find((y) => y.ID == x.trim()))
                        .filter((x) => x != null)
                ),
            ];
        },
        showProductsforProfileDialog(products, showAtElement) {
            this.popoverProducts = this.productsStringToUniqueArray(products);
            this.$refs.productList.showAt(showAtElement);
        },
        updatePaintlistRecordSawn(record, element) {
            element.disabled = true;
            optimizedPaintListApi
                .updateSawnForRecord(record.ID, element.checked)
                .catch(() => {
                    record.sawn = record.sawn == 1 ? 0 : 1;
                })
                .finally(() => {
                    element.disabled = false;
                });
        },
        updateTrackNrForPaintlist() {
            const trackNr = this.optimizedPaintList.trackNr;
            optimizedPaintListApi
                .updateTrackNr(trackNr, this.idParam)
                .then(() => {
                    showInfoMessage(
                        this.trans(
                            'pages.optimized_productlistview.sequence_number_updated'
                        )
                    );
                });
        },
        printProducts() {
            if (KeyHelper.isPressed('Shift')) {
                exportApi
                    .exportPaintListProductionLabels(this.idParam)
                    .then((response) => {
                        // Create a URL to the blob data
                        const blobUrl = window.URL.createObjectURL(
                            new Blob([response.data])
                        );

                        // Create a temporary link element and trigger a click event
                        const link = document.createElement('a');
                        link.href = blobUrl;
                        link.target = '_blank';
                        link.download = `production-labels-for-optimized-paint-list-${this.idParam}.pdf`;
                        link.style.display = 'none';
                        document.body.appendChild(link);
                        link.click();

                        // Clean up
                        window.URL.revokeObjectURL(blobUrl);
                        document.body.removeChild(link);
                    })
                    .catch((error) => {
                        console.error(error);
                    });

                return;
            }

            exportApi
                .printPaintListProductionLabels(
                    this.idParam,
                    this.selectedPrinterPostParameter
                )
                .then(() => {
                    showInfoMessage(
                        this.trans(
                            'pages.optimized_productlistview.labels_printed'
                        )
                    );
                });
        },
        showChildSawlines(sawlines) {
            this.childSawlines = sawlines;
            this.showChildsawlinesPopup = true;
        },
        updateUrgent() {
            optimizedPaintListApi
                .updateUrgent(this.idParam, this.optimizedPaintList.urgent)
                .catch(() => {
                    this.optimizedPaintList.urgent =
                        !this.optimizedPaintList.urgent;
                    showErrorMessage(
                        this.trans(
                            'pages.optimized_productlistview.closed_field_error'
                        )
                    );
                });
        },
        updateType() {
            optimizedPaintListApi
                .updateType(this.idParam, this.optimizedPaintList.type)
                .catch(() => {
                    showErrorMessage(
                        this.trans(
                            'pages.optimized_productlistview.type_field_error'
                        )
                    );
                });
        },
        load() {
            this.loading = true;

            this.allBaskets = [];
            this.showActionOverlay = false;
            this.optimizedPaintList = null;
            this.previous = null;
            this.next = null;

            this.$store.commit(
                'general/setPageTitle',
                this.trans(
                    'pages.optimized_productlistview.paint_list_number'
                ) +
                    ' ' +
                    this.idParam,
                { root: true }
            );

            Promise.all([
                optimizedPaintListApi.fetchAllBaskets().then((response) => {
                    this.allBaskets = response.data.data;
                }),
                optimizedPaintListApi
                    .fetch(this.idParam)
                    .then((response) => {
                        const optimizedPaintList = response.data.data;

                        if (!optimizedPaintList.reference) {
                            optimizedPaintList.reference =
                                optimizedPaintList.ID;
                        }

                        if (optimizedPaintList.records) {
                            optimizedPaintList.records.forEach((profile) => {
                                profile.selected = false;
                            });
                        }
                        if (optimizedPaintList.paintworkform) {
                            optimizedPaintListApi
                                .fetchPrevious(
                                    this.idParam,
                                    optimizedPaintList.paintworkform
                                )
                                .then((response) => {
                                    this.previous =
                                        response.data.data.previousPaintlist ||
                                        null;
                                });
                            optimizedPaintListApi
                                .fetchNext(
                                    this.idParam,
                                    optimizedPaintList.paintworkform
                                )
                                .then((response) => {
                                    this.next =
                                        response.data.data.nextPaintlist ||
                                        null;
                                });
                        }

                        this.oldpaintlistdescriptionValue =
                            optimizedPaintList.description;

                        this.optimizedPaintList = optimizedPaintList;
                    })
                    .catch(() => {
                        showErrorMessage(
                            this.trans(
                                'pages.optimized_productlistview.paint_list_load_error'
                            )
                        );
                    }),
            ]).then(() => {
                this.loading = false;
            });
        },
    },
};
</script>
